"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledArrows = exports.StyledMessage = exports.StyledEndIconBtn = exports.StyledStartIconWrapper = exports.StyledPasswordToggle = exports.StyledLabelText = exports.StyledLabel = exports.StyledInput = exports.StyledInputContainer = exports.StyledContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const BORDER_WIDTH = '1px';
const HEIGHT = 3;
const labelTransformation = (0, styled_components_1.css) `
  transform: translateY(-${1.25}rem) scale(0.75);
`;
const focusedLabelText = (0, styled_components_1.css)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.body.tinyText), { fontSize: theme.typography.body.text.fontSize })));
exports.StyledContainer = styled_components_1.default.div `
  ${({ isFullWidth }) => isFullWidth && 'width: 100%'};
  box-sizing: border-box;

  /* display */
  display: inline-flex;
  flex-direction: column;

  /* text */
  font-family: ${({ theme }) => theme.fontFamily.text};
`;
exports.StyledInputContainer = styled_components_1.default.div `
  /* positioning */
  position: relative;

  /* display */
  display: inline-flex;
  align-items: center;
`;
exports.StyledInput = styled_components_1.default.input `
  width: ${({ isFullWidth }) => (isFullWidth ? 'auto' : '100%')};

  /* box model */
  border: ${BORDER_WIDTH} solid;
  border-radius: 2px;
  box-sizing: border-box;
  height: ${HEIGHT}rem;
  outline: 0;
  overflow: hidden;

  /* Remove number arrow */
  &[type='number'] {
    -moz-appearance: textfield;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${({ theme, theme: { colors }, disabled, hasError, hasArrow, isPassword, clearable, startIcon }) => (0, styled_components_1.css) `
    /* box model */
    padding: 0 ${theme.space.s200};
    ${(isPassword || hasArrow) && `padding-right: ${theme.space.s500}`};
    ${!disabled && clearable && `padding-right: ${theme.space.s600}`};
    ${startIcon && `padding-left: ${theme.space.s600}`};

    /* color */
    background-color: ${colors.background.primary};
    border-color: ${colors.gray.s300};
    color: ${colors.text.body};

    &:focus {
      border-color: ${hasError ? colors.status.error : colors.gray.s400};
    }

    &:disabled {
      background-color: ${colors.gray.s200};
      border-color: ${colors.gray.s300};
      color: ${colors.gray.s500};
      cursor: not-allowed;
    }

    ${hasError && `border-color: ${colors.status.error}`};

    &:hover:not(:disabled):not(:focus) {
      ${!hasError && `border-color: ${theme.colors.gray.s400}`};
    }

    /* text */
    ${(0, styled_components_1.css)(theme.typography.body.text)};
    white-space: nowrap;
  `};
`;
exports.StyledLabel = styled_components_1.default.label `
  ${({ isFullWidth }) => isFullWidth && 'width: 100%'};
`;
exports.StyledLabelText = styled_components_1.default.span `
  /* positioning */
  position: absolute;
  left: -${({ theme }) => theme.space.s100};

  /* This top value works as align-items: center in a browser that has not flexbox support */
  top: calc((${HEIGHT}rem - ${({ theme }) => theme.typography.body.text.lineHeight}) / 2);

  /* box model */
  margin-left: calc(${({ theme }) => theme.space.s200} + ${BORDER_WIDTH});
  padding: 0 ${({ theme }) => theme.space.s100};

  /* color */
  color: ${({ hasError, theme }) => (hasError ? theme.colors.status.error : theme.colors.gray.s600)};
  background-color: transparent;

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.text)};
  white-space: nowrap;

  /* other */
  pointer-events: none;
  transform-origin: top left;
  transition:
    transform 0.2s ease-in-out,
    background-color 0.1s ease-in;
  transition-delay: 0s, 0.1s;

  ${exports.StyledInput}:focus ~ & {
    /* color */
    background-color: ${({ theme }) => theme.colors.background.primary};

    ${focusedLabelText}
    ${labelTransformation};
  }

  ${({ isActive }) => isActive &&
    (0, styled_components_1.css) `
      background-color: ${({ theme }) => theme.colors.background.primary};

      ${focusedLabelText}
      ${labelTransformation}
    `};

  ${exports.StyledInput}:hover:not(:disabled):not(:focus) ~ & {
    ${({ hasError, theme }) => !hasError &&
    (0, styled_components_1.css) `
        color: ${theme.colors.main.base};
      `}
  }
`;
exports.StyledPasswordToggle = styled_components_1.default.div `
  /* positioning */
  position: absolute;
  top: calc(50% - 0.75rem);
  right: 1rem;
  cursor: pointer;
`;
exports.StyledStartIconWrapper = styled_components_1.default.div `
  /* positioning */
  position: absolute;
  top: calc(50% - 0.75rem);
  left: 1rem;

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      pointer-events: none;

      svg > path {
        fill: ${({ theme }) => theme.colors.gray.s400};
      }
    `}
`;
exports.StyledEndIconBtn = styled_components_1.default.button `
  /* positioning */
  position: absolute;
  top: calc(50% - 0.75rem);
  right: 1rem;
  padding: 0;
  border: none;
  background: unset;
  cursor: ${({ disabled }) => (disabled ? '' : 'pointer')}
    ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
        pointer-events: none;

        svg > path {
          fill: ${({ theme }) => theme.colors.gray.s400};
        }
      `};
`;
exports.StyledMessage = styled_components_1.default.p `
  /* color */
  color: ${({ isError, theme }) => (isError ? theme.colors.status.error : theme.colors.text.body)};
  /* display */
  margin-top: ${({ theme }) => theme.space.s050};
  padding-left: ${({ theme }) => theme.space.s200};

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.tinyText)};
`;
exports.StyledArrows = styled_components_1.default.div `
  /* positioning */
  position: absolute;
  top: calc(50% - 1.1rem);
  right: 1rem;
  cursor: pointer;

  display: flex;
  flex-direction: column;

  button {
    padding: 0;
    border: none;
    background: unset;
    cursor: pointer;
  }
  button[disabled] {
    cursor: not-allowed;
    pointer-events: none;
    svg path {
      fill: ${({ theme }) => theme.colors.gray.s400};
    }
  }
`;
